// CP-111 (W1): the walk-in phone is mandatory — the visit auto-registers
// against it (loyalty stamps, membership visit burn, retention buckets).
// Mirrors the backend plausibility gate (PhoneNumberUtils.isPlausibleIndianMobile):
// normalize to 10 digits, require the Indian mobile range (6-9 start), and
// reject all-same-digit fillers (9999999999). Deliberately light — no OTP at
// the counter; plausible fakes are policed by customers missing their stamp.

export function normalizeIndianMobile(rawPhone) {
  const digits = String(rawPhone || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
  if (digits.length === 13 && digits.startsWith('091')) return digits.slice(3);
  if (digits.length === 14 && digits.startsWith('0091')) return digits.slice(4);
  return digits;
}

export function isPlausibleIndianMobile(rawPhone) {
  const normalized = normalizeIndianMobile(rawPhone);
  if (!/^[6-9]\d{9}$/.test(normalized)) return false;
  return new Set(normalized.split('')).size > 1;
}

export const WALKIN_PHONE_REQUIRED_MESSAGE = 'Customer phone is required';
export const WALKIN_PHONE_INVALID_MESSAGE = 'Enter a valid 10-digit mobile number';

/** Returns an error message, or null when the phone is acceptable. */
export function validateWalkinPhone(rawPhone) {
  if (!String(rawPhone || '').trim()) return WALKIN_PHONE_REQUIRED_MESSAGE;
  if (!isPlausibleIndianMobile(rawPhone)) return WALKIN_PHONE_INVALID_MESSAGE;
  return null;
}
